import { Table } from 'antd';
import type { TableProps } from 'antd';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';

import { components } from 'apiTyped/types';
import { getSubmissionFileName } from 'modules/Negoce/helper';

const SubmissionsTables = ({
  submissions = []
}: {
  submissions: components['schemas']['Submission'][];
}) => {
  const getLabelStatus = (status: string) => {
    switch (status) {
      case 'load_ok':
        return I18n.t('negoce.submissions.loadingHistory.statusFile.loaded');
      case 'ready':
        return I18n.t('negoce.submissions.loadingHistory.statusFile.ready');
      case 'error':
        return I18n.t('negoce.submissions.loadingHistory.statusFile.error');
      default:
        return status;
    }
  };

  const getFileNameWithoutIndex = (name: string) => {
    const filename = getSubmissionFileName(name);
    const lastIndex = filename.lastIndexOf('_');
    return lastIndex !== -1 ? filename.substring(0, lastIndex) : filename;
  };

  const columns: TableProps<components['schemas']['Submission']>['columns'] = [
    {
      title: I18n.t('negoce.submissions.loadingHistory.columns.created_at'),
      key: 'created_at',
      dataIndex: 'created_at',
      width: 105,
      sorter: (a, b) => {
        if (moment(a.created_at) < moment(b.created_at)) {
          return -1;
        }
        if (moment(a.created_at) > moment(b.created_at)) {
          return 1;
        }
        return 0;
      },
      defaultSortOrder: 'descend',
      render: (value: string) => moment(value).format('DD/MM/YYYY hh:mm')
    },
    {
      title: I18n.t('negoce.submissions.loadingHistory.columns.name'),
      key: 'file_path',
      dataIndex: 'file_path',
      sorter: (a, b) => {
        const a_fileName = getSubmissionFileName(a.file_path);
        const b_fileName = getSubmissionFileName(b.file_path);

        if (!a || !b || !a_fileName || !b_fileName) {
          return 0;
        }
        if (a_fileName < b_fileName) {
          return -1;
        }
        if (a_fileName > b_fileName) {
          return 1;
        }
        return 0;
      },
      render: (value: string) => getFileNameWithoutIndex(value)
    },
    {
      title: 'Email',
      key: 'user_email',
      dataIndex: 'user_email',
      width: 120
    },
    {
      title: I18n.t('negoce.submissions.loadingHistory.columns.status'),
      key: 'status',
      dataIndex: 'status',
      width: 80,
      // filters: [
      //   {
      //     text: I18n.t('negoce.submissions.loadingHistory.statusFile.loaded'),
      //     value: 'load_ok',
      //   },
      //   {
      //     text: I18n.t('negoce.submissions.loadingHistory.statusFile.ready'),
      //     value: 'ready',
      //   },
      //   {
      //     text: I18n.t('negoce.submissions.loadingHistory.statusFile.error'),
      //     value: 'error',
      //   },
      // ],
      // onFilter: (value, record) => record.status.indexOf(value as string) === 0,
      render: (value: string) => getLabelStatus(value)
    },
    {
      title: I18n.t('negoce.submissions.loadingHistory.columns.import_comment'),
      key: 'comment',
      dataIndex: 'import_comment',
      render: (value: string) => value || '-'
    }
  ];

  return (
    <Table
      columns={columns}
      dataSource={submissions.map(
        (submission: components['schemas']['Submission'], index: number) => ({
          key: index,
          ...submission
        })
      )}
      pagination={submissions.length > 10 ? { showSizeChanger: false } : false}
    />
  );
};

export default SubmissionsTables;
